// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3HDH-","name":"Header_name__BFNRe","birthday":"Header_birthday__3pd5u","skeleton":"Header_skeleton__1nsYu"};